import { createAction, props } from '@ngrx/store'
import { VendorResponse, CreateVendorPayload, UpdateVendorPayload } from './model'
import { Update } from '@ngrx/entity'

export const LoadVendors = createAction('[Vendor] Load Vendors')
export const LoadVendersComplete = createAction('[Vendor] Load Vendors Complete', props<{ items: VendorResponse[] }>())

export const AddVendor = createAction('[Vendor] Add vendor', props<{ payload: CreateVendorPayload }>())
export const AddVendorComplete = createAction('[Vendor] Add vendor Complete', props<{ item: VendorResponse }>())

export const GetVendorById = createAction('[Vendor] get vendor by id', props<{ id: string }>())
export const GetVendorByIdComplete = createAction(
  '[Vendor] get vendor by id Complete',
  props<{ item: VendorResponse }>()
)

export const UpdateVendor = createAction(
  '[Vendor] update vendor',
  props<{ id: string; payload: UpdateVendorPayload; silent?: boolean }>()
)
export const UpdateVendorComplete = createAction('[Vendor] update vendor Complete', props<{ item: VendorResponse }>())

export const UpdateVendors = createAction(
  '[Vendor] update vendors',
  props<{ items: { id: string; payload: UpdateVendorPayload }[] }>()
)
export const UpdateVendorsComplete = createAction(
  '[Vendor] update vendors Complete',
  props<{ updates: Update<VendorResponse>[] }>()
)

export const DeleteVendor = createAction('[Vendor] delete vendor', props<{ id: string; silent?: boolean }>())
export const DeleteVendorComplete = createAction('[Vendor] delete vendor Complete', props<{ id: string }>())

export const DeleteVendors = createAction('[Vendor] delete vendors', props<{ ids: string[] }>())
export const DeleteVendorsComplete = createAction('[Vendor] delete vendors Complete', props<{ ids: string[] }>())
